import React from 'react';
import { MeinBereichButton, MeinBereichPaper } from '../../../../components/ui-component/mein-bereich/MeinBereichComponents';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
import { enumT } from '../../../../utils/helper';

function BeendeteForderung() {
	const navigate = useNavigate();
	return (
		<>
			<MeinBereichPaper titleIcon={<EditIcon />} title={'Beendete Förderung'}>
				<MeinBereichButton buttonName="Förderarchiv ansehen" disabled={true} />
				<MeinBereichButton
					buttonName="Abschlussbereicht erstellen"
					onClick={() => {
						navigate(`/meine-antraege`, {
							state: {
								filter: {
									field: 'Antragsstatus_Antragsstatus',
									operator: 'contains',
									value: enumT('FoerderungAbgeschlossen'),
								},
							},
						});
					}}
				/>
				<MeinBereichButton buttonName="Urkunde ansehen" disabled={true} />
			</MeinBereichPaper>
		</>
	);
}

export default BeendeteForderung;
